export default {
    PAID: 2
};